import React from 'react'
import styles from './Service.module.css'
import {services} from './Service.js'

const Services = () => {
    
  return (
      <section id='services' className='bg-light pb-[57px] md:pb-[96px] mt-[54px] md:mt-[117px]'>
            <div className='container md:pl-[61px] md:pr-[57px] pt-[45px] md:pt-[64px] '>
                <h1 className=' text mb-[18px] md:mb-[66px]'>Our Services</h1>

                <div className='grid md:grid-cols-2 xl:grid-cols-3 place-items-center px-[20px] xl:px-0 gap-x-[30px] xl:gap-x-[78px] md:gap-x-[180px] gap-y-[40px] md:gap-y-[50px] '>
                    {services.map((service, i) => (
                        <div className={`w-full md:w-[355px] xl:w-[385px] bg-white pt-[50px] p-[14px] ${styles.box} hover:scale-105 transform duration-200 ease-out`} key={i}>
                        <div className='flex justify-center'>
                        <div className='flex items-center justify-center w-[50px] h-[50px] rounded-full bg-light '>
                            <img src={service.image} alt="/" /> 
                        </div>
                        </div>
                        <h3 className='mt-[18px] text-[16px] leading-[32px] md:leading-[24px] text-green text-center tracking-[0.005em] '>{service.title}</h3>
                        <p className=' mt-[18px] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-green text-center tracking-[0.005em]'>{service.desc}</p>
                    </div> 
                    ))}
                       
                </div>
            </div>
     </section>
  )
}

export default Services